












































































































































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../../RestClient";
import DateFormatter from "../../../shared/DateFormatter";
import OverlayWindow from "../../general/OverlayWindow.vue";
import Loading from "../../general/Loading.vue";
import ExpandableView from "../../controls/ExpandableView.vue";
import PointerMenu from "../../general/PointerMenu.vue";
import Calendar from "../../general/Calendar.vue";
import OverlayPictureViewer from "../../general/OverlayPictureViewer.vue";

import CalendarUtils from "../../../shared/CalendarUtils";
import CalendarEventJson from "../../../shared/CalendarEventJson";
import Utils from "../../../shared/Utils";
import { WeekDay } from "../../../shared/WeekDay";

import { SettingsPublicJson } from "../../../shared/SettingsJson";
import RentalBookingInfoJson from "../../../shared/RentalBookingInfoJson";
import ClientJson from "../../../shared/ClientJson";
import { RentalItemInfoJson, RentalItemAllowedTags } from "../../../shared/RentalItemJson";
import RentalBookingJson, {
  defaultRentalBookingJson,
  getRentalBookingTotalPrice,
} from "../../../shared/RentalBookingJson";
import RentalConditionJson, { getRentalConditionPrice } from "../../../shared/RentalConditionJson";
import CategoryTypeJson from "../../../shared/CategoryTypeJson";
import RentalTimeSlotJson from "../../../shared/RentalTimeSlotJson";

import RentalBookingAvailableCalendar from "../RentalBookingAvailableCalendar.vue";
import RentalBookingPeriodSelect from "../RentalBookingPeriodSelect.vue";
import RentalBookingConditionInput from "../RentalBookingConditionInput.vue";
import RentalBookingAdditionalConditions from "./RentalBookingAdditionalConditions.vue";

import { ValidationResult, Validation } from "../../../shared/Validation";
import { validateRentalBookingJsonCartItem } from "../../../shared/RentalBookingJson";

export default Vue.extend({
  name: "RentalProductDetails",
  components: {
    OverlayWindow,
    Loading,
    ExpandableView,
    PointerMenu,
    Calendar,
    OverlayPictureViewer,
    RentalBookingAvailableCalendar,
    RentalBookingPeriodSelect,
    RentalBookingConditionInput,
    RentalBookingAdditionalConditions,
  },
  props: {
    settings: Object as PropType<SettingsPublicJson | null>,
    rentalBookingInfo: Object as PropType<RentalBookingInfoJson | null>,
    clientData: Object as PropType<ClientJson>,
    restrictToTypeId: Number as PropType<number | null>,
    rentalCart: Array,
    productId: Number,
  },
  data() {
    return {
      RestClient: RestClient,
      DateFormatter: DateFormatter,
      CalendarUtils: CalendarUtils,
      Utils: Utils,
      defaultRentalBookingJson: defaultRentalBookingJson,
      RentalItemAllowedTags: RentalItemAllowedTags,
      supportsDatePicker: false,
      detailsTitle: "Details",
      selectedProductId: null as number | null,
      productDetails: null as RentalItemInfoJson | null,
      bookingDetails: null as RentalBookingJson | null,
      hasPricesOnRequest: false as boolean,
      dateToShow: null as Date | null,
      currentCalenderYearMonth: null as [number, number] | null,
      rentalConditionPrice: { priceIncludingVAT: 0, priceExcludingVAT: 0 } as {
        priceIncludingVAT: number;
        priceExcludingVAT: number;
      },
      overlayPictureViewerImgUrl: "",
      pickupSlots: null as RentalTimeSlotJson[] | null,
      returnSlots: null as RentalTimeSlotJson[] | null,
      toValidate: {} as any,
      validation: null as ValidationResult<RentalBookingJson> | null,
      submitValidation: false as boolean,
      loadingGeneral: false,
    };
  },
  created() {
    this.initProductDetails();
  },
  mounted() {
    this.checkDatePickerSupport();
  },
  methods: {
    initProductDetails() {
      this.selectedProductId = this.productId;
      this.loadProductDetails();
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    async loadProductDetails() {
      if (this.selectedProductId != null) {
        if (this.RestClient != null) {
          try {
            this.productDetails = await this.RestClient.getRentalItemInfo(this.selectedProductId);

            this.loadBookingDetails();
          } catch (e) {
            alert(e.message);
          }
        }
      } else {
        this.closeDetails();
      }
    },

    loadBookingDetails() {
      this.bookingDetails = defaultRentalBookingJson();

      let rentalItem: any = { ...this.productDetails };
      rentalItem.remarks = "";
      this.bookingDetails.rentalItem = rentalItem;
    },

    closeDetails() {
      this.$emit("closeOverlay");
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.bookingDetails != null) {
        this.validation = validateRentalBookingJsonCartItem(this.bookingDetails, this.settings?.rentalRequestPickupAndReturnTime);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    async loadPickupSlots(weekDay: WeekDay) {
      this.pickupSlots = null;

      if(this.settings?.rentalRequestPickupAndReturnTime) {
        let rc = RestClient;
        try {
          this.pickupSlots = await rc.getRentalPickupReturnSlots(weekDay);
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadReturnSlots(weekDay: WeekDay) {
      this.returnSlots = null;

      if(this.settings?.rentalRequestPickupAndReturnTime) {
        let rc = RestClient;
        try {
          this.returnSlots = await rc.getRentalPickupReturnSlots(weekDay);

          if(this.returnSlots.length <= 0 && this.productDetails?.contactlessReturn) {
            this.returnSlots = [{ "beginTime": "00:00", "endTime": "23:59" }];
          } else if(this.productDetails?.contactlessReturn) {
            const fristSlot = this.returnSlots[0];
            const lastSlot = this.returnSlots[this.returnSlots.length-1];
            this.returnSlots.unshift({ "beginTime": "00:00", "endTime": fristSlot.beginTime });
            this.returnSlots.push({ "beginTime": lastSlot.endTime, "endTime": "23:59" });
          }
        } catch (e) {
          alert(e.message);
        }
      }
    },

    calcRentalConditionPrice() {
      if (this.bookingDetails != null) {
        this.rentalConditionPrice = getRentalBookingTotalPrice(this.bookingDetails);
      }
    },

    addBookingToCart() {
      if (this.bookingDetails) {
        this.submitValidation = true;
        this.validation = validateRentalBookingJsonCartItem(this.bookingDetails, this.settings?.rentalRequestPickupAndReturnTime);

        if (this.validation != null && this.validation.isValid == true) {
          this.rentalCart.push(this.bookingDetails);

          this.closeDetails();
          alert("Das Produkt wurde dem Ausleihwagen hinzugefügt");
          this.$emit("changeTab", "rentalCart");
        } else {
          alert(
            "Das Produkt konnte nicht hinzugefügt werden. Überprüfen Sie bitte Ihre Eingaben und versuchen Sie es erneut."
          );
        }
      }
    },

    scrollToRentalSection() {
      const ele: HTMLInputElement = <HTMLInputElement>this.$refs["rentalSection"];
      ele.scrollIntoView({ behavior: "smooth" });
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    bookingDetails: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.calcRentalConditionPrice();
        }
      },
      deep: true,
    },

    bookingDetailsBeginDate: {
      handler(val, oldVal) {
        if (val) {
          this.loadPickupSlots(new Date(val).getDay());
        }

        if(val !== oldVal) {
          if(this.bookingDetails) this.bookingDetails.pickupTime = null;
        }
      },
    },

    bookingDetailsEndDate: {
      handler(val, oldVal) {
        if (val) {
          this.loadReturnSlots(new Date(val).getDay());
        }

        if(val !== oldVal) {
          if(this.bookingDetails) this.bookingDetails.returnTime = null;
        }
      },
    }
  },

  computed: {
    rentalConditionsPriceNotOnRequest(): RentalConditionJson[] {
      if (this.productDetails != null) {
        return this.productDetails.rentalConditions.filter((i: RentalConditionJson) => {
          if (i.isOnRequestOnly || i.isManagementOnly) {
            this.hasPricesOnRequest = true;
            return false;
          } else {
            return true;
          }
        });
      } else {
        return [];
      }
    },

    rentalConditionsFilteredByTypes(): RentalConditionJson[] {
      if (this.productDetails != null) {
        return this.rentalConditionsPriceNotOnRequest.filter((rc: RentalConditionJson) => {
          if (rc.restrictToTypes == null) {
            return true;
          } else if (this.restrictToTypeId) {
            if (rc.restrictToTypes.find((t) => t.ID == this.restrictToTypeId)) return true;
          } else {
            if (this.clientData != null && this.clientData.types != null) {
              return this.clientData.types && this.clientData.types.length > 0
                ? rc.restrictToTypes.some((i: CategoryTypeJson) =>
                    this.clientData.types!.map((t: CategoryTypeJson) => t.ID).includes(i.ID)
                  )
                : false;
            } else {
              return false;
            }
          }
        });
      } else {
        return [];
      }
    },

    additionalConditionsOnlyManagement(): RentalConditionJson[] {
      if (this.productDetails != null) {
        return this.productDetails.additionalRentalConditions.filter((i: RentalConditionJson) => i.isManagementOnly);
      } else {
        return [];
      }
    },

    selectableAdditionalConditions(): RentalConditionJson[] {
      if (this.productDetails != null) {
        return this.productDetails.additionalRentalConditions.filter((i: RentalConditionJson) => {
          if (i.isOnRequestOnly || i.isManagementOnly) {
            return false;
          } else {
            return true;
          }
        });
      } else {
        return [];
      }
    },

    additionalConditionsFilteredByTypes(): RentalConditionJson[] {
      if (this.productDetails != null) {
        return this.selectableAdditionalConditions.filter((rc: RentalConditionJson) => {
          if (rc.restrictToTypes == null) {
            return true;
          } else if (this.restrictToTypeId) {
            if (rc.restrictToTypes.find((t) => t.ID == this.restrictToTypeId)) return true;
          } else {
            if (this.clientData != null && this.clientData.types != null) {
              return this.clientData.types && this.clientData.types.length > 0
                ? rc.restrictToTypes.some((i: CategoryTypeJson) =>
                    this.clientData.types!.map((t: CategoryTypeJson) => t.ID).includes(i.ID)
                  )
                : false;
            } else {
              return false;
            }
          }
        });
      } else {
        return [];
      }
    },

    bookingDetailsBeginDate(): string | null {
      return this.bookingDetails ? this.bookingDetails.beginDate : null;
    },

    bookingDetailsEndDate(): string | null {
      return this.bookingDetails ? this.bookingDetails.endDate : null;
    },
  },
});
